var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "후원하기",
      "tabActive": "일시후원",
      "bg": "/images/sub/visual/sv3.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('donation-form', {
    attrs: {
      "code": "일시후원"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }